export default {
  data () {
    return {
      tabView: 'tab1'
    }
  },
  computed: {
    rows () {
      const config = this.reportConfigData
      // reatrun array of cols naumbers
      let cols = []
      for (let key in config) {
        cols.push(config[key].col)
      }
      let uniq = [...new Set(cols)]
      return uniq.sort()
    },
    reportConfigData () {
      return {}
    }
  },
  asyncData () {
    return Promise.resolve(1)
  }
}
